import { useEffect } from 'react';
import { PosterStudioFrame } from '../frame/PosterStudioFrame';
import { PosterStudioLocation } from '../functions/posterStudioLocation';
import { usePosterStudioExit } from '../functions/usePosterStudioExit';
import { usePosterStudioSession } from '../functions/usePosterStudioSession';
import { PosterStudioFailure } from './PosterStudioFailure';

/**
 * One attempt at the studio: the frame, or why it failed. The studio draws its
 * own ‹ on its top screens and sends `exit`; Android's back asks it first.
 */
export function PosterStudioSession({
  location,
  orgId,
  storeId,
  onLeave,
  onRetry,
}: {
  location: PosterStudioLocation;
  orgId: number;
  storeId: number;
  onLeave: () => void;
  onRetry: () => void;
}) {
  const { phase, toStudio$, exits$, onEvent, requestClose } =
    usePosterStudioSession({ orgId, storeId });
  const exit = usePosterStudioExit({ requestClose, onLeave });

  useEffect(() => {
    const subscription = exits$.subscribe(onLeave);
    return () => subscription.unsubscribe();
  }, [exits$, onLeave]);

  return phase.kind === 'failed' ? (
    <PosterStudioFailure
      message={phase.message}
      actions={[
        { label: '返回', onPress: onLeave, primary: false },
        { label: '重试', onPress: onRetry, primary: true },
      ]}
    />
  ) : (
    <PosterStudioFrame
      url={location.url}
      origin={location.origin}
      toStudio$={toStudio$}
      onEvent={onEvent}
      onExit={exit}
    />
  );
}
